import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { CURRENCY } from './../../../../../utils/currency'
import { Item } from './Item'

export const List = ({ list, isChildren, activeItem }) => {
  const { formatedUnit } = useFormatCurrency(SCREEN.PEER_ANALYSIS)

  return (
    <ul>
      {list.map((item, index) => {
        const isActive = activeItem === item.itemId
        return (
          <Item
            key={index}
            item={item}
            label={
              isChildren
                ? `${item.label} (${
                    item.unit === CURRENCY.VND ? formatedUnit : item.unit
                  })`
                : `${item.label}`
            }
            children={item.children}
            isI18n={item.isI18n}
            isChildren={isChildren}
            isTopItem={index === 0}
            activeItem={activeItem}
            isActive={isActive}
          />
        )
      })}
    </ul>
  )
}
